import React from 'react';
import moment from 'moment';

import { Section } from '../..';
import CustomFieldType from './CustomFieldType';
import { defaultPropTypes } from '../AdditionalData';
import { checkSectionCondition } from '../../../Form.helpers';

const CustomTextFields = ({ field }) => {
    const formatAnswer = (questionType, textAnswer) => {
        if (textAnswer) {
            switch (questionType) {
                case CustomFieldType.Date:
                    return moment(textAnswer).format('DD.MM.YYYY');
                default:
                    return textAnswer;
            }
        } else {
            return 'brak odpowiedzi';
        }
    };
    const textAnswerArray = field.map(({ textAnswer }) => textAnswer);
    const renderedSection = checkSectionCondition(textAnswerArray);

    return (
        <Section.Conditional
            condition={Boolean(field.length) && renderedSection}
        >
            {({ renderField }) => (
                <>
                    {field.map(({ order, questionType, textAnswer, textQuestion }) => renderField(textQuestion, formatAnswer(questionType, textAnswer), null, `customQ_${order}`))}
                </>
            )}
        </Section.Conditional>
    );
};
CustomTextFields.propTypes = defaultPropTypes;

export default CustomTextFields;
